"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Button = _interopRequireDefault(require("../Button"));
var _reactI18next = require("react-i18next");
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(_ref) {
  var isOpen = _ref.isOpen,
    toggle = _ref.toggle,
    onSure = _ref.onSure;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isShowAgain = _useState2[0],
    setShowAgain = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    open: isOpen,
    onClose: toggle
  }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, t('dialog.confirm.title')), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: " font-semibold text-gray-dark"
  }, t('compose.send.confirm.uploadingAttachment')), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "select-none"
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    color: "primary",
    disableRipple: true,
    onChange: function onChange() {
      return setShowAgain(function (isShowAgain) {
        return !isShowAgain;
      });
    },
    checked: isShowAgain,
    autoFocus: true
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-2 text-xs text-gray-light"
  }, t('checkbox.doNotShowAgain'))))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "white",
    className: "w-24",
    size: "sm",
    onClick: toggle
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "ml-4 w-24",
    size: "sm",
    onClick: function onClick() {
      onSure(isShowAgain);
      toggle();
    }
  }, t('button.okay'))));
};
//# sourceMappingURL=index.js.map